// extracted by mini-css-extract-plugin
export default {"productHero":"productHero_TmJcT"};